import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: "What's the free trial for the e-commerce leads database?",
  answer: 'Every new account gets free credits to explore our e-commerce leads database before committing to a paid plan. Search Shopify stores, WooCommerce sites, and more — view store owner emails and launch email sequences at no cost. <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" class="text-blue-600 font-semibold hover:underline">Sign up for free →</a>'
}, {
  question: 'Which e-commerce platforms do you track?',
  answer: 'We track over 400 e-commerce platforms including Shopify, WooCommerce, BigCommerce, Magento, Wix, Squarespace, and many more. You can filter the database by platform to find exactly the Shopify stores or other e-commerce sites you need.'
}, {
  question: 'How do I find e-commerce leads on Openmart?',
  answer: 'Finding e-commerce leads is simple — use our search filters to narrow by platform (e.g. Shopify stores), category (e.g. Shopify apparel stores), rating, review count, and more. You can target the biggest Shopify stores or filter for emerging Shopify sites in any niche. Every result includes verified owner contacts ready for outreach.'
}, {
  question: 'Can I access Shopify statistics and store analytics?',
  answer: 'Yes. Our e-commerce leads database includes detailed Shopify statistics for every store — average ticket size, product count, technology stack, revenue estimates, review ratings, and a full list of categories. You can analyze trends across millions of Shopify stores and other e-commerce platforms.'
}, {
  question: 'Can I see the store owner emails before paying?',
  answer: 'Yes! A major advantage of Openmart is our verified store owner emails. You can search the database, see the names and roles of the owners of e-commerce stores, and confirm the data exists before you spend any credits to unlock the actual email addresses.'
}, {
  question: 'How does the built-in email sequencing work?',
  answer: "Our platform includes built-in email sequencing so you don't have to export CSVs to a third-party tool. You can connect your email accounts, build multi-step email campaigns, and launch them directly to your e-commerce leads from within Openmart."
}, {
  question: 'Can I export the e-commerce database to my CRM?',
  answer: 'Yes. While we offer built-in email sequencing, you can also export your e-commerce leads directly to Salesforce, HubSpot, or download them as a CSV file for your own workflows.'
}];
export function EcommerceFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 bg-slate-50" data-id="element-1046">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1047">
        <div className="text-center mb-10" data-id="element-1048">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-1049">
            Frequently asked <span className="text-blue-600" data-id="element-1050">questions</span>
          </h2>
        </div>

        <div className="space-y-0 divide-y divide-slate-200" data-id="element-1051">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="py-4" data-id="element-1052">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left flex justify-between items-center focus:outline-none group" aria-expanded={isOpen} data-id="element-1053">
                  <span className={`text-base font-semibold transition-colors pr-8 ${isOpen ? 'text-blue-600' : 'text-slate-900 group-hover:text-blue-600'}`} data-id="element-1054">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-blue-600' : 'text-slate-400 group-hover:text-blue-600'}`} data-id="element-1055" />
                </button>
                <AnimatePresence data-id="element-1056">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-1057">
                      <div className="pt-3 pb-1 text-sm text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} data-id="element-1058" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}